import React from 'react'
import { Icon } from 'semantic-ui-react'
import { css } from 'emotion'
import { queryStringEncode } from '../util/Serializers'

export const styles = {}
styles.button = css`
  background-color: rgb(27, 149, 224);
  border-radius: 3px;
  font-size: 11px;
  height: 20px;
  padding-left: 6px;
  padding-right: 8px;
  text-decoration: none;
  color: white;
  display: inline-block;
  line-height: 18px;
  margin-left: 3px;
  :hover {
    color: white;
  }
`

/**
 * Button element.
 */
export const TweetButton = ({
  slug = '/',
  text = 'Esmer games blog',
  tags = [],
}) => {
  const params = queryStringEncode({
    text,
    hashtags: tags.join(','),
    url: `https://esmer-games.github.io${slug}`,
  })
  return (
    <a
      className={styles.button}
      href={`https://twitter.com/intent/tweet?${params}`}
      data-size="large"
    >
      <Icon name="twitter" /> Tweet
    </a>
  )
}
